import React, { useEffect, useState } from "react";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { NEW_APPROVAL_STATUS, STATUS_DATA } from "./constants";
import dummyData from "./auto.json";
import { getUniqueKey } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import {
  fetchAllPostPromisedData,
  getCookie,
} from "../../../../common/utils/methods/commonMethods/utilityMethod";
import {
  hasLumpsumConcession,
  hasPaymentOrLoanConcession,
} from "./categorySelector";
import { getProgressiveConcessionListWithCustom } from ".";
import moment from "moment";
import { failureToast } from "../../../../common/utils/methods/toasterFunctions/function";

export const NEW_TERM_AFTER_THAT = 2627;
export const EFFECTIVE_DATE = moment("2025-10-25"); //-- todo need to change on deployment date

export const isNewTermStudent = (studentDetails) => {
  const applicationDate = moment(studentDetails?.createdOn);
  if (
    applicationDate.isSameOrAfter(EFFECTIVE_DATE) &&
    studentDetails.termValue >= NEW_TERM_AFTER_THAT
  ) {
    return true;
  }

  return false;
};

export const getExtraCompValue = (a, b, c, d, e) => {
  // debugger
  if (a !== 0) {
    return a;
  }

  const nonZeroParams = [b, c, d, e].filter((param) => param !== 0);

  if (nonZeroParams.length === 0) {
    // All other parameters are zero, return a (which is also zero)
    return a;
  }

  return Math.min(...nonZeroParams);
};

export const canRevoke = (status, isApproved) => {
  return !isApproved &&
    ["Pending", "L1_APPROVED", "L2_APPROVED", "L3_APPROVED"].includes(status)
    ? true
    : false;
};

export const canModify = (isApproved) => {
  return isApproved ? true : false;
};

export const getCurrentStatus = (status, isApproved, isCapitaized = false) => {
  //console.log("status",status)
  if (isApproved) {
    return isCapitaized ? "Approved" : "APPROVED";
  } else if (
    ["Pending", "L1_APPROVED", "L2_APPROVED", "L3_APPROVED"].includes(status)
  ) {
    return isCapitaized ? "Pending" : "PENDING";
  } else if (["L1_RECHECK", "L2_RECHECK", "L3_RECHECK"].includes(status)) {
    return isCapitaized ? "Recheck" : "RECHECK";
  } else if (["L1_REJECT", "L2_REJECT", "L3_REJECT"].includes(status)) {
    return isCapitaized ? "Rejected" : "REJECTED";
  } else {
    return "NA";
  }
};

export const getFeeMapping = (allSlabs) => {
  const feeMap = {
    adminFeeConcession: false,
    classFeeConcession: false,
    regFeeConcession: false,
    techFeeConcession: false,
    tutionFeeConcession: false,
  };

  allSlabs.forEach((item) => {
    if (
      item?.action !== "DELETE" &&
      (item?.fromBE || item?.action === "CREATE" || item?.action === "UPDATE")
    ) {
      feeMap.adminFeeConcession =
        feeMap.adminFeeConcession || item.adminFeeConcession > 0;
      feeMap.classFeeConcession =
        feeMap.classFeeConcession || item.classFeeConcession > 0;
      feeMap.regFeeConcession =
        feeMap.regFeeConcession || item.regFeeConcession > 0;
      feeMap.techFeeConcession =
        feeMap.techFeeConcession || item.techFeeConcession > 0;
      feeMap.tutionFeeConcession =
        feeMap.tutionFeeConcession || item.tutionFeeConcession > 0;
    }
  });
  return feeMap;
};

export const GetDisplayData = ({ status, isApproved }) => {
  // alert(status)
  const sts =
    STATUS_DATA[
      isApproved
        ? "Approved"
        : ["L1_REJECT", "L2_REJECT", "L3_REJECT"].includes(status)
        ? "Rejected"
        : ["L1_RECHECK", "L2_RECHECK", "L3_RECHECK"].includes(status)
        ? "Recheck"
        : ""
    ];
  // alert(sts)
  return sts !== undefined ? (
    <div
      className="text-center py-2 mb-3"
      style={{
        backgroundColor: sts?.BCOLOR,
        color: sts?.COLOR,
        borderRadius: "6px",
        fontSize: "14px",
      }}
    >
      <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ margin: "0px 6px 3px 0px" }}
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.65151 0.961394L13.4974 9.37148C13.604 9.62251 13.6507 9.82663 13.664 10.0387C13.6907 10.5341 13.5174 11.0157 13.1774 11.3863C12.8375 
              11.7556 12.3776 11.9736 11.8776 12H2.11928C1.91265 11.9874 1.70602 11.9405 1.51271 11.8679C0.546211 11.4781 0.0796231 10.3815 0.47289 9.43093L5.35207 0.955449C5.51871 0.657519 5.772 0.400546 
              6.08528 0.235396C6.99179 -0.26732 8.14493 0.0629796 8.65151 0.961394ZM7.57836 6.50382C7.57836 6.82091 7.3184 7.08581 6.99846 7.08581C6.67851 7.08581 6.41189 6.82091 6.41189 6.50382V4.63498C6.41189 
              4.31724 6.67851 4.06026 6.99846 4.06026C7.3184 4.06026 7.57836 4.31724 7.57836 4.63498V6.50382ZM6.99846 9.34505C6.67851 9.34505 6.41189 9.08015 6.41189 8.76373C6.41189 8.44598 6.67851 8.18174 6.99846 
              8.18174C7.3184 8.18174 7.57836 8.44003 7.57836 8.75646C7.57836 9.08015 7.3184 9.34505 6.99846 9.34505Z"
          fill={sts?.SVG_COLOR}
        />
      </svg>
      {sts?.DISPLAY_TEXT}
    </div>
  ) : null;
};

export const checkForAutoConcession = (
  category,
  autoConcessionType,
  concessionDataId
) => {
  console.log("subCategory", category?.subCategory);
  const isSubSubCategoryExists = category?.subCategory?.isSubSubCategoryExists;
  const subOrSubsubCategory = isSubSubCategoryExists
    ? category?.subCategory?.subSubCategory
    : category?.subCategory;
  const concessionSlab = subOrSubsubCategory?.concessionSlabDto;
  console.log("concessionSlab", concessionSlab);
  return {
    action: "CREATE",
    id: getUniqueKey(),
    categoryId: category?.id,
    category: {
      ...subOrSubsubCategory,
      concessionMethodType: `AUTO_${autoConcessionType}`,
      isSubSubCategory: isSubSubCategoryExists ? true : false,
      concessionDataId: concessionDataId,
      categoryCode: category?.categoryCode,
      categoryDispVal: category?.categoryDispVal,
      subCategoryDispVal: category?.subCategory?.subCategoryDispVal,
      isLumpsum: category?.subCategory?.isLumpSum,
    },
    code: [{ label: category?.categoryCode, value: category?.categoryCode }],
    concessionSubCategoryId: isSubSubCategoryExists
      ? null
      : subOrSubsubCategory?.id,
    concessionSubSubCategoryId: isSubSubCategoryExists
      ? subOrSubsubCategory?.id
      : null,
    isLumpSumCategory: category?.isLumpSumCategory || null,
    concessionCategoryCode: category?.categoryCode,
    concessionRemarks: null,
    updatedOn: null,
    scholarshipCriteria: subOrSubsubCategory?.scholarshipCriteria,
    scholarshipCriteriaValue:
      subOrSubsubCategory?.scholarshipCriteria === "QUALIFIED"
        ? 0
        : subOrSubsubCategory?.scholarshipCriteriaValue ?? null,
    concessionSlabId: concessionSlab?.id,
    adminFeeConcession: concessionSlab?.admissionFee || 0,
    classFeeConcession: concessionSlab?.classFee || 0,
    techFeeConcession: concessionSlab?.techFee || 0,
    tutionFeeConcession: concessionSlab?.tuitionFee || 0,
    regFeeConcession: concessionSlab?.regFee || 0,
    concessionParameter: subOrSubsubCategory?.concessionParameter,
    concessionDocuments: [],
    concessionType: "DEFINED",
    isAutoConcession: true,
    concessionMethodType: `AUTO_${autoConcessionType}`,
    concessionDataId: concessionDataId,
    isNewSlab: true,
  };
};

export const getLowestNetPayApi = async ({
  applicationId,
  applicationQuotationDetailsId,
}) => {
  return await fetchAllPromisedData(
    `${endpoint.checkModifyAllowed}/${applicationId}?quotationId=${applicationQuotationDetailsId}`,
    true,
    true
  );
};

export const getPaidItemListApi = async ({
  applicationId,
  applicationQuotationDetailsId,
  forCentralizedAdmission,
}) => {
  if (!applicationId || !applicationQuotationDetailsId) return [];

  let url = `${endpoint.paidItemTypeList}/${applicationId}?quotationId=${applicationQuotationDetailsId}`;

  if (forCentralizedAdmission) {
    url = updateUrlForCentralizedAdm(url);
  }

  return await fetchAllPromisedData(url, true, true);
};

export const getAllPaidItemListApi = async (
  applicationId,
  psid,
  businessArea
) => {
  if (!applicationId || !psid || !businessArea) return [];
  let url = `${endpoint.getAllPaymentItems}/?psid=${psid}&applicationNumber=${applicationId}&businessArea=${businessArea}`;
  return await fetchAllPromisedData(url, true, true);
};

const checkForPaidItem = (cmprFlag, item) => {
  return ["UNAPPROVED_CMPR", "CMPR"].includes(cmprFlag)
    ? false
    : item?.paidAmount > 0;
};

export const formatPaidItemType = (response) => {
  if (!response) return [];
  if (response && response?.code === 200) {
    return response?.data?.filter(
      (item) => item?.fullyPaid || item?.paidAmount > 0
    );
  }
};

export const getPaidItemTypeList = (paidItemTypes) =>
  paidItemTypes?.map((item) => item["itemType"]) || [];

const getTotalConcessionOfEachComponent = (componentMap) => {
  // key:componentKey, value: total concession
  const componentMapWithConcession = {};
  for (let component in componentMap) {
    const { flAmt, ylAmt, ulAmt, oAmt } = componentMap[component];
    componentMapWithConcession[component] = flAmt + ylAmt + ulAmt + oAmt + 0;
  }
  return componentMapWithConcession;
};
// sum of pending + nonPending
export const calculateTotalConcessionMax = (componentMap, pendingConcMap) => {
  // ✅ Step 1: Check if all pending values are zero
  const hasAnyPendingValue = Object.values(pendingConcMap).some(
    ({ flAmt, ylAmt, ulAmt, oAmt }) =>
      flAmt !== 0 || ylAmt !== 0 || ulAmt !== 0 || oAmt !== 0
  );

  // If all pending values are zero, return 0 directly
  if (!hasAnyPendingValue) {
    return 0;
  }

  // ✅ Step 2: Normal calculation
  const componentMapWithConcession = {};

  for (let component in componentMap) {
    const { flAmt, ylAmt, ulAmt, oAmt } = componentMap[component];
    const {
      flAmt: flAmtPending,
      ylAmt: ylAmtPending,
      ulAmt: ulAmtPending,
      oAmt: oAmtPending,
    } = pendingConcMap[component];

    componentMapWithConcession[component] =
      flAmt +
      ylAmt +
      ulAmt +
      oAmt +
      flAmtPending +
      ylAmtPending +
      ulAmtPending +
      oAmtPending;
  }

  return Math.max(...Object.values(componentMapWithConcession));
};

export const isPendingConcessionZero = (totalPendingConsession = {}) => {
  return Object.values(totalPendingConsession).every(
    ({ flAmt = 0, ylAmt = 0, ulAmt = 0, oAmt = 0 }) =>
      flAmt === 0 && ylAmt === 0 && ulAmt === 0 && oAmt === 0
  );
};


export const getMaximumConcession = (componentMap, pendingForApprovalPercentage) => {
  // debugger
  const concessionMap = getTotalConcessionOfEachComponent(componentMap);
  return Math.max(...Object.values(concessionMap));
};
export const getMaximumProgressiveConcession = (concessionMap) => {
  return Math.max(...Object.values(concessionMap));
};

export const regAndAdmissionComp = ["100000000029", "100000000030"];

const errorMessage =
  "The applied concession value is not permitted. Please adjust the concession to be either higher or lower than the existing applied concessions";

export const checkCmplrEdgeCase = ({
  appliedConcessionMax,
  pendingConcessionMax,
  maxConcessionBE,
  minConcessionBE,
}) => {
  if (!minConcessionBE) return false;
  if (
    appliedConcessionMax > maxConcessionBE ||
    pendingConcessionMax > maxConcessionBE
  )
    return;
  const isAppliedWithinRange =
    appliedConcessionMax >= minConcessionBE &&
    appliedConcessionMax <= maxConcessionBE;
  const isPendingWithinRange =
    pendingConcessionMax >= minConcessionBE &&
    pendingConcessionMax <= maxConcessionBE;

  return isAppliedWithinRange || isPendingWithinRange ? errorMessage : false;
};
export const employeeBenefitsDropdown = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];

export const getTutionFeeTotal = (consession) => {
  const keys = ["flAmt", "ylAmt", "ulAmt", "oAmt"];
  return parseFloat(
    keys
      .reduce((sum, key) => sum + (consession["01"]?.[key] ?? 0), 0)
      .toFixed(2)
  );
};

export const getKeyComponentsKeyMapping = (feeMap) => {
  const { classFee, adminFee, regFee, techFee, tutionFee } = feeMap;
  return {
    ...feeMap,
    "01": tutionFee,
    "04": classFee,
    "05": techFee,
    29: regFee,
    30: adminFee,
  };
};

export const setCustomConcessionQuota = (
  { totalCustomConcessionPercentage },
  customConfig,
  { concessionMap: concession }
) => {
  if (!customConfig) return false;
  // debugger

  const {
    l1ApprovalOverAllPercentage: l1OverallCap,
    l1ApprovalPercentage: l1QuotaCap,
    l2ApprovalOverAllPercentage: l2OverallCap,
    l2ApprovalPercentage: l2QuotaCap,
    l3ApprovalOverAllPercentage: l3OverallCap,
    l3ApprovalPercentage: l3QuotaCap,
  } = customConfig;

  // Convert to numbers for safe calculations
  const totalConcessionUsed = Number(getTutionFeeTotal(concession)) || 0;
  const totalCustomPercentage = Number(totalCustomConcessionPercentage) || 0;

  // Ensure inputs are valid numbers
  if (isNaN(totalConcessionUsed) || isNaN(totalCustomPercentage)) return false;

  const totalConcession = totalConcessionUsed + totalCustomPercentage;

  let remainingConcession = totalCustomPercentage;
  const concessionQuota = { l1Quota: 0, l2Quota: 0, l3Quota: 0 };
  // Exclude levels where the overall cap is lower than the requested custom percentage
  const levels = [
    { cap: l1OverallCap, quotaCap: l1QuotaCap, key: "l1Quota" },
    { cap: l2OverallCap, quotaCap: l2QuotaCap, key: "l2Quota" },
    { cap: l3OverallCap, quotaCap: l3QuotaCap, key: "l3Quota" },
  ].filter((level) => level.cap > totalConcessionUsed);

  // Distribute the concession across levels
  for (const level of levels) {
    const { cap, quotaCap, key } = level;
    const usedItsOwnQuota = cap - totalConcessionUsed;
    const availableQuota = Math.min(
      remainingConcession,
      Math.min(quotaCap, usedItsOwnQuota)
    );

    concessionQuota[key] = availableQuota;
    remainingConcession -= availableQuota;

    // Stop if no remaining concession
    if (remainingConcession <= 0) break;
  }

  return concessionQuota;
};
export const setCustomConcessionQuotaV3 = (
  { totalCustomConcessionPercentage },
  customConfig,
  overAllProgressive,
  applicationId
) => {
   
  if (!customConfig){
    failureToast("Configuration for concession quota not found. Please contact administrator.")
    return { error: "Config missing" }

  } ;

  const {
    l1ApprovalOverAllPercentage: l1OverallCap,
    l1ApprovalPercentage: l1QuotaCap,
    l2ApprovalOverAllPercentage: l2OverallCap,
    l2ApprovalPercentage: l2QuotaCap,
    l3ApprovalOverAllPercentage: l3OverallCap,
    l3ApprovalPercentage: l3QuotaCap,
  } = customConfig;

  const slabProgressive = Number(overAllProgressive) || 0;
  const customTotal = Number(totalCustomConcessionPercentage) || 0;
    if(customTotal  === 0){
    return { l1Quota: 0, l2Quota: 0, l3Quota: 0, Remaining: 0, allowed: true };
  }

  if (isNaN(slabProgressive) || isNaN(customTotal)) {
    return { error: "Invalid numbers passed" };
  }

  const sumQuotaCaps = l1QuotaCap + l2QuotaCap + l3QuotaCap;
  if (customTotal > sumQuotaCaps) {
    return { error: `Custom concession ${customTotal}% exceeds total level quota cap ${sumQuotaCaps}%` };
  }

  const maxLevelOverall = Math.max(l1OverallCap, l2OverallCap, l3OverallCap);
  if (slabProgressive> maxLevelOverall) {
    return { error: `Overall progressive ${slabProgressive}% exceeds max allowed overall ${maxLevelOverall}%` };
  }

  let remaining = customTotal;
  const quota = { l1Quota: 0, l2Quota: 0, l3Quota: 0 };

  const levels = [
    { overallCap: l1OverallCap, quotaCap: l1QuotaCap, key: "l1Quota" },
    { overallCap: l2OverallCap, quotaCap: l2QuotaCap, key: "l2Quota" },
    { overallCap: l3OverallCap, quotaCap: l3QuotaCap, key: "l3Quota" },
  ].filter(lvl => lvl.overallCap >= slabProgressive);

  for (const lvl of levels) {
    //const headroom = lvl.overallCap - slabProgressive;
   // const allowedCustom = Math.min(lvl.quotaCap, headroom);
    const allocated = Math.min(remaining, lvl.quotaCap);

    quota[lvl.key] = allocated;
    remaining -= allocated;
    if (remaining <= 0) break;
  }


  if (remaining > 0) {
    return { error: `Breach: ${remaining}% custom concession left after allocation finished` };
  }


  return { ...quota, Remaining: remaining,  allowed: true };
};


// Error messages
const ERR_CUSTOM_EXCEEDS_LEVEL_CAP = (custom, max, appId) =>
  `Custom Concession ${custom}% exceeds limit of ${max}% for Application Id: ${appId}. Please revisit the concession and try.`;

const ERR_OVERALL_EXCEEDS_MAX = (overall, max, appId) =>
  `Overall Concession ${overall}% exceeds limit of ${max}% for Application Id: ${appId}. Please revisit the concession and try.`;

const ERR_TOTAL_PERMISSIBLE_EXCEEDED = (
  customConcesssionPer,
  totalPermissible
) =>
  `Custom concession(${customConcesssionPer}%) exceeds permissible limits for L1+L2+L3 is ${totalPermissible}`;

export const setCustomConcessionQuotaNew = (
  { totalCustomConcessionPercentage }, // User entered custom concession
  customConfig, // Config with overall and custom caps
  // { concessionMap: concession },
  definedConcession,
  applicationId // Already defined concession
) => {
  debugger;
  if (!customConfig) return false;

  const {
    l1ApprovalOverAllPercentage: l1OverallCap,
    l1ApprovalPercentage: l1CustomCap,
    l2ApprovalOverAllPercentage: l2OverallCap,
    l2ApprovalPercentage: l2CustomCap,
    l3ApprovalOverAllPercentage: l3OverallCap,
    l3ApprovalPercentage: l3CustomCap,
    // maxOverallConcessionPercentage = 75,
  } = customConfig;

  const maxOverallConcessionPercentage = Math.max(
    l1OverallCap,
    l2OverallCap,
    l3OverallCap
  );

  // const definedConcession = Number(getTutionFeeTotal(concession)) || 0;
  const customConcession = Number(totalCustomConcessionPercentage) || 0;

  if (isNaN(definedConcession) || isNaN(customConcession)) return false;

  const maxCustomConcessionPercentage = l1CustomCap + l2CustomCap + l3CustomCap; //30

  if (customConcession > maxCustomConcessionPercentage) {
    return {
      error: ERR_CUSTOM_EXCEEDS_LEVEL_CAP(
        customConcession,
        maxCustomConcessionPercentage,
        applicationId
      ),
    };
  }

  //definedConcession -> 35
  //customConcession -> 30

  const l1Permissible =
    definedConcession < l1OverallCap // 40
      ? Math.min(l1OverallCap - definedConcession, l1CustomCap) //10
      : 0; //5

  const l2Permissible =
    definedConcession < l2OverallCap //60
      ? Math.min(l2OverallCap - definedConcession, l2CustomCap) //10
      : 0; // 10

  const l3Permissible =
    definedConcession < l3OverallCap //75
      ? Math.min(l3OverallCap - definedConcession, l3CustomCap) //10
      : 0; //10

  if (
    customConcession > 0 &&
    definedConcession + customConcession > maxOverallConcessionPercentage
  ) {
    return {
      error: ERR_OVERALL_EXCEEDS_MAX(
        definedConcession + customConcession,
        maxOverallConcessionPercentage,
        applicationId
      ),
    };
  }

  const totalPermissible = l1Permissible + l2Permissible + l3Permissible;
  if (totalPermissible < customConcession) {
    return {
      error: ERR_TOTAL_PERMISSIBLE_EXCEEDED(customConcession, totalPermissible),
    };
  }

  let remaining = customConcession;
  const quota = { l1Quota: 0, l2Quota: 0, l3Quota: 0 };

  quota.l1Quota = Math.min(l1Permissible, remaining);
  remaining -= quota.l1Quota;

  quota.l2Quota = Math.min(l2Permissible, remaining);
  remaining -= quota.l2Quota;

  quota.l3Quota = Math.min(l3Permissible, remaining);

  return quota;
};

export const updateUrlForCentralizedAdm = (url) => {
  const delimiter = url?.includes("?") ? "&" : "?";
  return `${url}${delimiter}opportunityOwnerId=${getCookie("userId")}`;
};

/**
 * Returns true if both Lumpsum and Payment/Loan concessions are applied together.
 */
export const hasInvalidConcessionCombination = (
  currentConcessionList,
  allAppliedConcessionList
) => {
  // debugger
  const combinedList = [
    ...(currentConcessionList || []),
    ...(allAppliedConcessionList || []),
  ];

  return (
    hasLumpsumConcession(combinedList) &&
    hasPaymentOrLoanConcession(combinedList)
  );
};

const isEnableCRPCheck = false;
export const hasInvalidConcessionCRP = (
  currentConcessionList,
  allAppliedConcessionList = [],
  applicationDetails
) => {
  // debugger

  if (!isEnableCRPCheck) return false;

  const isCustomConcession = allAppliedConcessionList.some(
    (item) => item?.concessionType === "CUSTOM"
  );
  const isCRPConcession = currentConcessionList.some(
    (item) => item?.category?.subCategoryDispVal === "CRPM"
  );
  const yearAfterThat = 2627; //isProgressiveCheckPoint
  return (
    isCRPConcession &&
    isCustomConcession &&
    applicationDetails.termValue >= yearAfterThat
  );
};

export const updateCashierOfficeApi = (cashierOffice, applicationId) => {
  if (!applicationId || !cashierOffice) return false;
  return fetchAllPostPromisedData(
    `${endpoint.studentDetails.updateStudentApplicationDetails}/${applicationId}`,
    { cashierOffice },
    "put"
  );
};

export const getStudentContactDetails = async(psid) => {
  const response = await fetchAllPromisedData(
    `${endpoint.studentDetails.getStudentContactDetails}/${psid}`,
      true
    );
if(response?.code === 200){
  return  response?.data?.studentAddressDetailDTOList[0];
}
};



/**
 * Calculate total concession amount and percentage
 * @param {Object} totals - An object where each key has { conAmt, totalGross }
 * @returns {{totalConcessionPercentage: string, totalConcessionAmount: number}}
 */
export function calculateTotalConcession(totals) {
  // Sum of all concession amounts
  const totalConAmt = Object.keys(totals).reduce((sum, key) => {
    const val = parseFloat(totals[key]?.conAmt) || 0;
    return sum + val;
  }, 0);

  // Sum of all totalGross amounts
  const totalGross = Object.keys(totals).reduce((sum, key) => {
    const val = parseFloat(totals[key]?.totalGross) || 0;
    return sum + val;
  }, 0);

  // Calculate percentage safely
  const percent =
    totalGross > 0 ? ((totalConAmt / totalGross) * 100).toFixed(2) : "0.00%";

  return {
    totalConcessionAmount: Math.round(totalConAmt * 100) / 100,
    totalConcessionPercentage: percent,
  };
}



export function applyProgressiveToRequestDefined(requestDefined, useProgressive = false) {
  
  // Helper function to accept 0 as a valid value
  const getProgressiveValue = (progressiveStr, originalVal) => {
    const parsed = parseFloat(progressiveStr);
    // If parsed is a valid number (including 0), use it. 
    // If it returns NaN (undefined or invalid), use originalVal.
    return !isNaN(parsed) ? parsed : originalVal;
  };

  return requestDefined.map((slab) => {
    if (!useProgressive || !slab.progressiveConcession) return {
      ...slab,
      orgAdminFeeConcession: slab.adminFeeConcession,
      orgRegFeeConcession: slab.regFeeConcession,
      orgClassFeeConcession: slab.classFeeConcession,
      orgTechFeeConcession: slab.techFeeConcession,
      orgTutionFeeConcession: slab.tutionFeeConcession,
    };

    return {
      ...slab,
      // Store original values
      orgAdminFeeConcession: slab.adminFeeConcession,
      orgRegFeeConcession: slab.regFeeConcession,
      orgClassFeeConcession: slab.classFeeConcession,
      orgTechFeeConcession: slab.techFeeConcession,
      orgTutionFeeConcession: slab.tutionFeeConcession,
      orgOldClassFeeConcession: slab.orgOldClassFeeConcession,
      orgOldTutionFeeConcession: slab.orgOldTutionFeeConcession,

      // Fix: Use the helper function instead of ||
      adminFeeConcession: getProgressiveValue(slab.progressiveConcession.adminFee?.progressiveConcessionPercent, slab.adminFeeConcession),
      regFeeConcession: getProgressiveValue(slab.progressiveConcession.regFee?.progressiveConcessionPercent, slab.regFeeConcession),
      classFeeConcession: getProgressiveValue(slab.progressiveConcession.classFee?.progressiveConcessionPercent, slab.classFeeConcession),
      techFeeConcession: getProgressiveValue(slab.progressiveConcession.techFee?.progressiveConcessionPercent, slab.techFeeConcession),
      tutionFeeConcession: getProgressiveValue(slab.progressiveConcession.tutionFee?.progressiveConcessionPercent, slab.tutionFeeConcession),
    };
  });
}

export function applyProgressiveToRequestCustom(
  requestDefined,
  useProgressive = false
) {
  return requestDefined.map((slab) => {
    if (!useProgressive || !slab.progressiveConcession) return slab;

    return {
      ...slab,
      // Store original values
      orgAdminFeeConcession: slab.adminFeeConcession,
      orgRegFeeConcession: slab.regFeeConcession,
      orgClassFeeConcession: slab.classFeeConcession,
      orgTechFeeConcession: slab.techFeeConcession,
      orgTutionFeeConcession: slab.tutionFeeConcession,

      // Replace with progressive values
      adminFeeConcession:
        parseFloat(
          slab.progressiveConcession.adminFee?.progressiveConcessionPercent
        ) || slab.adminFeeConcession,
      regFeeConcession:
        parseFloat(
          slab.progressiveConcession.regFee?.progressiveConcessionPercent
        ) || slab.regFeeConcession,
      classFeeConcession:
        parseFloat(
          slab.progressiveConcession.classFee?.progressiveConcessionPercent
        ) || slab.classFeeConcession,
      techFeeConcession:
        parseFloat(
          slab.progressiveConcession.techFee?.progressiveConcessionPercent
        ) || slab.techFeeConcession,
      tutionFeeConcession:
        parseFloat(
          slab.progressiveConcession.tutionFee?.progressiveConcessionPercent
        ) || slab.tutionFeeConcession,
    };
  });
}

export function calculateTotalFromProgressive(
  // list,
  progressiveDefinedConcessions,
  progressiveCustomConcession,
  feeMap
  // customConcession = null
) {
  debugger;
  // :one: Get the progressive list (using your existing function)

  // const allAppliedConcession  = getProgressiveConcessionListWithCustom(list, feeMap, customConcession);
  // const progressiveList = [...allAppliedConcession['definedConcessions'], {...allAppliedConcession['customConcessions']}]

  const progressiveList = [
    ...progressiveDefinedConcessions,
    progressiveCustomConcession,
  ];
  // :two: Initialize totals
  const totals = {
    totalDefinedConcessionAmount: 0,
    totalCustomConcessionAmount: 0,
    totalConcessionAppliedAmount: 0,
    totalDefinedConcessionPercentage: 0,
    totalCustomConcessionPercentage: 0,
    totalConcessionAppliedPercentage: 0,
    componentPercentages: {},
  };
  // :three: Sum up per-component totals from progressive rows
  const feeKeys = Object.keys(feeMap);
  feeKeys.forEach((key) => (totals.componentPercentages[key] = 0));
  progressiveList.forEach((row) => {
    feeKeys.forEach((key) => {
      const pc = row.progressiveConcession[key];
      if (pc) {
        const amount = parseFloat(pc.progressiveAmount) || 0;
        const percent = parseFloat(pc.progressiveConcessionPercent) || 0;
        totals.componentPercentages[key] += percent;
        if (row.concessionType === "CUSTOM") {
          totals.totalCustomConcessionAmount += amount;
        } else {
          totals.totalDefinedConcessionAmount += amount;
        }
      }
    });
  });

  totals.totalConcessionAppliedAmount =
    totals.totalDefinedConcessionAmount + totals.totalCustomConcessionAmount;
  const totalDefinedFee = feeKeys.reduce(
    (acc, key) =>
      acc +
      (progressiveDefinedConcessions.some((r) => r[key + "Concession"])
        ? feeMap[key]
        : 0),
    0
  );
  const totalCustomFee = feeKeys.reduce(
    (acc, key) =>
      acc +
      (progressiveCustomConcession?.feeComp?.some((fc) => fc.feeName === key)
        ? feeMap[key]
        : 0),
    0
  );
  const totalFee = Object.values(feeMap).reduce((a, b) => a + b, 0);
  totals.totalDefinedConcessionPercentage = totalDefinedFee
    ? (totals.totalDefinedConcessionAmount * 100) / totalDefinedFee
    : 0;
  totals.totalCustomConcessionPercentage = totalCustomFee
    ? (totals.totalCustomConcessionAmount * 100) / totalCustomFee
    : 0;
  totals.totalConcessionAppliedPercentage = totalFee
    ? (totals.totalConcessionAppliedAmount * 100) / totalFee
    : 0;

  Object.keys(totals).forEach((key) => {
    const val = totals[key];
    totals[key] = Number.isFinite(val) ? Number(val.toFixed(2)) : val;
  });

  return totals;
}

export function getDefinedProgressiveSummary(concessionList) {
  if (!Array.isArray(concessionList)) return {};

  const defined = concessionList.filter(
    (item) => item.concessionType === "DEFINED"
  );

  const summary = {
    regFee: 0,
    adminFee: 0,
    classFee: 0,
    techFee: 0,
    tutionFee: 0,
  };

  defined.forEach((item) => {
    const prog = item.progressiveConcession || {};
    Object.keys(summary).forEach((key) => {
      summary[key] += parseFloat(prog[key]?.progressiveConcessionPercent || 0);
    });
  });

  let maxComponent = null;
  let maxValue = -Infinity;

  Object.entries(summary).forEach(([key, value]) => {
    if (value > maxValue) {
      maxValue = value;
      maxComponent = key;
    }
  });

  return {
    summaryMap: Object.fromEntries(
      Object.entries(summary).map(([k, v]) => [k, v.toFixed(2)])
    ),
    maxComponent,
    maxValue: maxValue.toFixed(2),
  };
}



// Extract magic number to constant
const SUCCESS_CODE = 200;

export const useStudentContactDetails = (psid) => {
  // 1. Initialize state
  const [contactDetails, setContactDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // 2. 'isActive' flag to track if this specific effect run is still valid
    let isActive = true;

    // Reset state only if psid exists (optional, depending on UX preference)
    if (!psid) {
        setContactDetails(null);
        return;
    }

    const sortedByLatestDate = (rows)=>{
      if(!rows || rows.length===0) return null;
     return   [...rows].sort(
  (a, b) => new Date(b.updatedOn) - new Date(a.updatedOn)
)[0];
    }

    const fetchDetails = async () => {
      setIsLoading(true);
      setError(null);
      
      try {
        const url = `${endpoint.studentDetails.getStudentContactDetails}/${psid}`;
        
        // 3. Await the data
        const response = await fetchAllPromisedData(url, true);

        // 4. Check 'isActive' before updating state to prevent race conditions
        if (isActive) {
          if (response?.code === SUCCESS_CODE) {
             // Safe extraction using optional chaining
             const details = sortedByLatestDate(response?.data?.studentAddressDetailDTOList) || null;
             setContactDetails(details);
          } else {
             // Handle API logical errors (e.g. code 404 or 500 inside response)
             setContactDetails(null); 
             // Optional: Set error state here if you want to show it in UI
          }
        }
      } catch (err) {
        if (isActive) {
          console.error("Error fetching contact details:", err);
          setError(err);
        }
      } finally {
        if (isActive) {
          setIsLoading(false);
        }
      }
    };

    fetchDetails();

    // 5. Cleanup function: sets flag to false when component unmounts or psid changes
    return () => {
      isActive = false;
    };

  }, [psid]); // Re-run effect only when psid changes

  return { contactDetails, isLoading, error };
};



export const isAlreadyAboveLimit = (slab)=>{
  return slab.some(item=>item.scholarshipCriteriaValue>=100)
}